// stores/itemStore.js
import { create } from "zustand";
import axios from "axios";
import authHeader from "../../services/auth-header";
import { APP_URL } from "../../services/http-common";
import useGlobalStore from "./globalStoreZs";

const URLEntityName = APP_URL + "report";

const useReportStore = create((set, get) => ({
  reportsZs: [],
  reportZs: {},
  //   linesZs: [],
  //   items: [],
  //   loading: false,
  //   searchTextLinesZs: "",
  //   currentPageLinesZs: 0,
  //   pageSizeLinesZs: 10,
  //   setSearchTextLinesZs: (text) => {
  //     set({ searchTextLinesZs: text, currentPageLinesZs: 0 });
  //     // get().setFilterLinesZs();
  //   },
  //   setPageLinesZs: (page) => {
  //     set({ currentPageLinesZs: page });
  //     get().setFilterLinesZs();
  //   },
  //   totalPagesLinesZs: () => {
  //     const { linesZs, searchTextLinesZs, pageSizeLinesZs } = get();
  //     const filtered = linesZs.filter((item) =>
  //       item?.name?.toLowerCase().includes(searchTextLinesZs.toLowerCase())
  //     );
  //     return Math.ceil(filtered.length / pageSizeLinesZs);
  //   },
  //   filterLinesZs: [],
  //   setFilterLinesZs: () => {
  //     const { linesZs, searchTextLinesZs, currentPageLinesZs, pageSizeLinesZs } =
  //       get();
  //     const filtered = linesZs.filter((row) => {
  //       return Object.keys(row)
  //         .filter((key) => key !== "id") // Exclude 'id' from the search
  //         .some((key) => {
  //           const value = row[key];
  //           // Check if the value is a string and contains the search text
  //           return (
  //             typeof value === "string" &&
  //             value.toLowerCase().includes(searchTextLinesZs.toLowerCase())
  //           );
  //         });
  //     });
  //     const totalPages = Math.ceil(filtered.length / pageSizeLinesZs);

  //     // Ensure the current page does not exceed total pages
  //     const currentPage = Math.min(currentPageLinesZs, totalPages - 1);

  //     const start = currentPageLinesZs * pageSizeLinesZs;
  //     const end = start + pageSizeLinesZs;

  //     set({
  //       filterLinesZs: filtered.slice(start, end),
  //       totalPagesLinesZs: totalPages,
  //       currentPageLinesZs: currentPage,
  //       total: filtered.length,
  //     });
  //   },

  fetchReportsZs: async (page = 0, search = "") => {
    useGlobalStore.getState().setLoadingZs(true);
    set({ loading: true });
    try {
      const response = await axios.get(URLEntityName, {
        headers: authHeader(),
      });
      set({ reportsZs: response.data });
    } catch (error) {
      console.error("Error fetching items", error);
    }
    set({ loading: false });
    useGlobalStore.getState().setLoadingZs(false);
  },

  getReportZs: async (id) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.get(URLEntityName + "/" + id, {
        headers: authHeader(),
      });
      set({
        reportZs: response.data,
        // linesZs: newLines,
        // filterLinesZs: newLines,
        // total: newLines.length,
        // searchTextLinesZs: "",
        // currentPageLinesZs: 0,
      });
    } catch (error) {
      console.error("Error fetching items", error);
    }
    set({ loading: false });
    useGlobalStore.getState().setLoadingZs(false);
  },

  createReportZs: async (item) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.post(URLEntityName, item, {
        headers: authHeader(),
      });
      //   await useFormInputesSubmissionStore.getState().getReportZs(item?.id);
      await useReportStore.getState().fetchReportsZs();
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs("Rekordi u shtua me sukses!");
    } catch (error) {
      console.error("Error fetching items", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },

  updateReportZs: async (item) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.put(URLEntityName + "/" + item?.id, item, {
        headers: authHeader(),
      });
      //   await useFormInputesSubmissionStore.getState().getReportZs(item?.id);
      await useReportStore.getState().fetchReportsZs();
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs("Rekordi u ndryshuar me sukses!");
    } catch (error) {
      console.error("Error fetching items", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },

  deleteReportZs: async (id) => {
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.delete(URLEntityName + "/" + id, {
        headers: authHeader(),
      });
      await useReportStore.getState().fetchReportsZs();
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs("Rekordi u fshi me sukses!");
    } catch (error) {
      console.error("Error delete ", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },
}));

export default useReportStore;
